<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="options.showClose"
    :custom-class="dialogClass"
    width="30%"
    align-center
    :before-close="handleClose"
    destroy-on-close
  >
    <template slot="title">
      <div>
        <slot name="messagebox-icon">
          <i
            v-if="type === 'error'"
            class="el-icon-warning-outline el-message-box__status"
            :class="iconClass"
          />
        </slot>

        <slot name="messagebox-header">{{ options.title }}</slot>
      </div>
    </template>
    <div class="messagebox-dialog__body">
      <slot name="messagebox-body">{{ options.message }}</slot>
    </div>
    <template slot="footer">
      <span class="dialog-footer">
        <el-button :class="[options.cancelButtonClass]" @click="handleCancel">
          {{ options.cancelButtonText }}
        </el-button>
        <el-button
          :class="[options.confirmButtonClass]"
          type="primary"
          @click="handleConfirm"
        >
          {{ options.confirmButtonText }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
const optionInit = {
  dialogClass: '',
  title: 'Message Dialog Title',
  message: 'This is a message',
  showClose: false,
  showCancelButton: true,
  cancelButtonText: '取消',
  cancelButtonClass: 'btn btn-bordered--default',
  showConfirmButton: true,
  confirmButtonText: '確定',
  confirmButtonClass: 'btn btn--alert'
}

export default {
  props: {
    type: {
      type: String,
      default: 'error'
    },
    option: {
      type: Object,
      default() {
        return optionInit
      }
    }
  },
  data() {
    return {
      options: {
        ...optionInit,
        ...this.option
      },
      dialogVisible: true
    }
  },
  computed: {
    dialogClass() {
      const classStr = this.options.dialogClass
      return classStr ? `messagebox ${classStr}` : 'messagebox'
    },
    iconClass() {
      const iconMap = {
        success: 'el-icon-success',
        warning: 'el-icon-warning',
        error: 'el-icon-error'
      }
      return iconMap[this.type] || ''
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
      // this.handleClose()
    },
    handleCancel() {
      this.$emit('cancel')
      this.handleClose()
    },
    handleClose() {
      this.$emit('cancel')
    }
  }
}
</script>
